import { useToastStore, type ToastType } from '@/lib/toast';

const styleByType: Record<ToastType, string> = {
  success: 'bg-emerald-600 text-white',
  error: 'bg-rose-600 text-white',
  info: 'bg-slate-800 text-white',
  warn: 'bg-amber-500 text-white',
};

const iconByType: Record<ToastType, string> = {
  success: 'OK',
  error: '!',
  info: 'i',
  warn: '!',
};

export function ToastContainer() {
  const toasts = useToastStore((s) => s.toasts);
  const dismiss = useToastStore((s) => s.dismiss);

  if (toasts.length === 0) return null;

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-4 z-50 flex flex-col items-center gap-2 px-4">
      {toasts.map((t) => (
        <div
          key={t.id}
          role="status"
          className={`pointer-events-auto flex w-full max-w-md items-start gap-3 rounded-lg px-4 py-3 shadow-lg ${styleByType[t.type]}`}
        >
          <span
            aria-hidden
            className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-white/20 text-xs font-bold"
          >
            {iconByType[t.type]}
          </span>
          <p className="flex-1 text-sm leading-snug">{t.message}</p>
          <button
            type="button"
            onClick={() => dismiss(t.id)}
            className="text-sm font-semibold opacity-80 hover:opacity-100"
            aria-label="Fechar"
          >
            x
          </button>
        </div>
      ))}
    </div>
  );
}

export default ToastContainer;
